import { Link } from "react-router-dom";
import { Calculator } from "lucide-react";

// Every grade landing page's real route + label, so users and crawlers alike
// have an actual path to these pages from every page on the site (they were
// previously only reachable via sitemap.xml, with zero internal links).
const GRADE_LINKS = [
  ["Kindergarten", "/grade/kindergarten"],
  ["Grade 1", "/grade/1"],
  ["Grade 2", "/grade/2"],
  ["Grade 3", "/grade/3"],
  ["Grade 4", "/grade/4"],
  ["Grade 5", "/grade/5"],
  ["Grade 6", "/grade/6"],
  ["Grade 7", "/grade/7"],
  ["Grade 8", "/grade/8"],
  ["Algebra 1", "/grade/9"],
  ["Geometry", "/grade/10"],
  ["Algebra 2", "/grade/11"],
  ["Pre-Calculus", "/grade/12"],
  ["Calculus", "/grade/calculus"],
];

export const Footer = () => (
  <footer className="no-print mt-20 border-t-[3px] border-[#0A0A0A] bg-white">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10 grid sm:grid-cols-4 gap-8">
      <div>
        <div className="flex items-center gap-2">
          <div className="w-9 h-9 bg-brand-yellow border-[3px] border-[#0A0A0A] rounded-lg flex items-center justify-center">
            <Calculator strokeWidth={3} className="w-5 h-5" />
          </div>
          <span className="font-heading text-xl font-bold">iLoveMathWorksheets</span>
        </div>
        <p className="mt-3 text-sm text-muted-foreground max-w-xs">
          Free, instant math worksheets for K-12. Generate, solve, print, repeat.
        </p>
      </div>
      <div className="sm:col-span-2">
        <p className="font-heading text-sm uppercase tracking-widest font-bold mb-3">Browse by Grade — Common Core Aligned</p>
        <ul className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-2 text-sm">
          {GRADE_LINKS.map(([label, path]) => (
            <li key={path}>
              <Link to={path} className="text-muted-foreground hover:text-[#0A0A0A] hover:underline">
                {label}
              </Link>
            </li>
          ))}
        </ul>
        <Link
          to="/topics"
          className="inline-block mt-3 text-sm font-bold text-brand-coral hover:underline"
        >
          Browse all topics →
        </Link>
      </div>
      <div>
        <p className="font-heading text-sm uppercase tracking-widest font-bold mb-3">Powered by</p>
        <ul className="space-y-2 text-sm text-muted-foreground">
          <li>AI-powered explanations</li>
          <li>Made with care for curious minds</li>
        </ul>
      </div>
    </div>
    <div className="border-t-[3px] border-[#0A0A0A] py-4 text-center text-xs font-semibold">
      © {new Date().getFullYear()} iLoveMathWorksheets · Built with grit.
    </div>
  </footer>
);

export default Footer;
